import { useQuery } from "@tanstack/react-query";

import { api } from "@utils/api";

import { useQueryErrorHandling } from "@hooks/useQueryErrorHandling";

import { patientNoteQKeys } from "./queryKeys";


const select = (res: any) => {
  //   console.log(res.data);

  if (res.data.tags.length) {
    const newData: string[] = [];

    return res.data.tags;
  }
  return null;
};

export const useGetPatientNoteTags = () => {
  const handleErrors = useQueryErrorHandling();

  return useQuery({
    queryKey: patientNoteQKeys.tags(),
    queryFn: () => {
      return api.get(`notes/tags`);
    },
    select,
    staleTime: Infinity,

    onError: (res: any) => {
      console.error("[From Get Patient Note Tags]", res);
      handleErrors(res, "query");
    },
  });
};
